var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.pageLoaded)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader-content"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v(_vm._s(_vm.$t(`Loading...`)))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }